export class RankService {
  constructor($resource, ApiService) {
    "ngInject";

    this.$resource = $resource;
    this.apiService = ApiService;
    this.endpoint = this.apiService.getResourceUrl("/rank/list");

    this.resource = this.$resource(this.endpoint);
  }
  getRankList() {
    const promise = this.resource.get().$promise;
    return promise.then(({ details }) => details.list);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/rank/rank.service.js